import { useMemo } from 'react'
import { useEntityBreadcrumbs } from 'context/layout/LayoutConfigContext'
import { ContactImportWizard } from './ContactImportWizard'

export default function ContactImportPage() {
  // Represent the import flow in the header breadcrumb (CONTACTS > Import Contacts).
  // Cleared automatically on unmount by the hook. The array MUST be memoized —
  // useEntityBreadcrumbs keys its effect on this reference, so a fresh literal
  // every render would loop (setEntityBreadcrumbs → re-render → new array → …).
  const breadcrumbs = useMemo(() => [{ label: 'Import Contacts' }], [])
  useEntityBreadcrumbs(breadcrumbs)
  return <ContactImportWizard />
}
